import api from './index';

export class ApiHealthService {
  /**
   * Test API connection and health
   */
  static async testConnection(): Promise<{
    isConnected: boolean;
    responseTime: number;
    error?: string;
    apiUrl: string;
  }> {
    const startTime = Date.now();
    const apiUrl = api.defaults.baseURL || 'Unknown';
    
    try {
      const response = await api.get('/health', { timeout: 2000 });
      const responseTime = Date.now() - startTime;
      
      return {
        isConnected: true,
        responseTime,
        apiUrl,
      };
    } catch (error: any) {
      const responseTime = Date.now() - startTime;
      
      return {
        isConnected: false,
        responseTime,
        apiUrl,
        error: error.message || 'Connection failed',
      };
    }
  }

  /**
   * Get API status information
   */
  static async getApiStatus() {
    try {
      const response = await api.get('/status');
      return response.data;
    } catch (error) {
      console.error('Failed to get API status:', error);
      throw error;
    }
  }

  /**
   * Test authentication endpoint
   */
  static async testAuth() {
    try {
      const response = await api.get('/auth/test');
      return response.data;
    } catch (error) {
      console.error('Auth test failed:', error);
      throw error;
    }
  }
}

export default ApiHealthService;
